import HundredBricksAPIError from '../../HundredBricksAPIError';
class DisableAutomaticInvoicingError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('DisableAutomaticInvoicingError', ...args);
    }
}
export default DisableAutomaticInvoicingError;
